export default __webpack_public_path__ + "static/media/headsetIcon.b67a5868.svg";